module.exports = __webpack_public_path__ + "static/sheep-781ccc91adefeb783468f981a0c92f98.svg";